<template>
  <div id="app">
    <div class="header">
      <el-row>
        <el-col :span="7" :offset="17">
          <div class="menu">
            <div :class="['menu-item',{active:index===active}]" v-for="(item,index) in menuList" :key="index" @click="changePage(index)">
              {{item.name}}
              <div class="sub-title" v-if="index===active">{{item.en}}</div>
            </div>
          </div>
          </el-col>
      </el-row>
    </div>
    <router-view/>
  </div>
</template>
<script>
  // @ is an alias to /src
  export default {
    name: 'APP',
    data(){
      return{
        active:0,
        menuList:[
          {
            name:'个人主页',
            en:'INFORMATION',
            url:'/'
          },
          {
            name:'我的作品',
            en:'WORKS',
            url:'/works'
          },
          {
            name:'工作经历',
            en:'EXPERIENCE',
            url:'/about'
          }
        ]
      }
    },
    methods:{
      changePage(index){
        if(this.active!==index){
          this.active=index;
          this.$router.push(this.menuList[index].url)
        }
      }
    },
    created() {
      switch (this.$route.name) {
        case 'Works':
          this.active = 1
          break
        case 'Detail':
          this.active = 1
          break
        case 'About':
          this.active = 2
          break
        default:
          this.active = 0
      }
    }
  }
</script>
<style>
  body{
    background: #1d1d1d;
    padding: 0;
    margin: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
  .not_ready{
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-family: 'software';
    text-align: center;
    color: #cccccc;
  }
</style>
<style scoped>

  .header{
    width: 1200px;
    margin: auto;
    /*background: #999999;*/
    /*height: 60px;*/
  }
  .header .menu{
    padding-top: 10px;
    width: 100%;
    display: flex;
    height: 55px;
    color: rgba(255,255,255,.5);
  }
  .header .menu .menu-item{
    flex: 1;
    font-size: 1rem;
    cursor: pointer;
    /*font-weight: bold;*/
  }
  .header .menu .menu-item .sub-title{
    font-size: .8rem;
    margin-top: 5px;
    font-weight: normal;
  }
  .menu-item:hover,.active{
    color: #ffffff;
  }
</style>
